export const WagonsDailyUsageColor = {
  INACTIVE: '#e1e8ed',
  ACTIVE: '#0f9960',
  PAUSED: '#ffd966',
};
